import { statusMap } from '../utils/helpers'
import type { OrderStatus } from '../types'

interface StatusBadgeProps {
  status: OrderStatus
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const s = statusMap[status] || { text: status, className: 'status-tag-pending' }
  return (
    <span className={`status-tag ${s.className}`}>{s.text}</span>
  )
}
